// Filter chips for son product grids/carousels.
//
// MARKUP CONTRACT (see Son_Product_Grid)
//   <nav data-son-filter-bar>
//     <button data-son-filter="*">Show all</button>
//     <button data-son-filter="some-slug">…</button>
//   </nav>
//   …followed, under the same parent, by items carrying
//   data-son-filter-terms="slug-a slug-b". Filtered-out items (or their
//   .swiper-slide box) get .son-filter-hidden; Swiper instances are told to
//   update so a filtered carousel re-lays-out its track.

function bindFilterBar(bar) {
    if (bar.dataset.sonFilterReady) {
        return;
    }
    bar.dataset.sonFilterReady = 'true';

    const scope = bar.parentElement;

    bar.addEventListener('click', (event) => {
        let tab = event.target.closest('[data-son-filter]');
        if (!tab) {
            return;
        }

        // clicking the active chip deselects it -> back to show-all
        if (tab.classList.contains('is-active') && tab.dataset.sonFilter !== '*') {
            tab = bar.querySelector("[data-son-filter='*']") || tab;
        }

        const filter = tab.dataset.sonFilter;

        bar.querySelectorAll('[data-son-filter]').forEach((other) => {
            const active = other === tab;
            other.classList.toggle('is-active', active);
            other.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        scope.querySelectorAll('[data-son-filter-terms]').forEach((item) => {
            const terms = (item.dataset.sonFilterTerms || '').split(/\s+/);
            const show = filter === '*' || terms.includes(filter);
            const box = item.closest('.swiper-slide') || item;
            box.classList.toggle('son-filter-hidden', !show);
        });

        scope.querySelectorAll('.swiper').forEach((el) => {
            if (el.swiper) {
                el.swiper.update();
            }
        });
    });
}

function initFilterBars(root = document) {
    root.querySelectorAll('[data-son-filter-bar]').forEach(bindFilterBar);
}

document.addEventListener('DOMContentLoaded', () => initFilterBars());

// re-bind after Elementor editor re-renders an element
window.addEventListener('elementor/frontend/init', () => {
    if (window.elementorFrontend && window.elementorFrontend.hooks) {
        window.elementorFrontend.hooks.addAction('frontend/element_ready/global', ($element) => {
            initFilterBars($element[0] || document);
        });
    }
});
